import requester from 'utils/requester';
import * as types from './types';
import { showLoader, hideLoader } from '../loader';
import { get } from 'lodash';
import apiCubic from 'config/api-cubic';
import innerAnalyticsVolia from 'helpers/innerAnalyticsVolia';
import { INIT_UI_LANGUAGE } from 'constants/languages';

export const fetchPromocode = ({ code, onSuccess, errorModal }) => async (dispatch, getState) => {
  dispatch({ type: types.FETCH, payload: code });
  dispatch(showLoader());

  const {
    data: { contractNumber },
  } = getState().profile;

  const authToken = btoa(`${apiCubic.users.billing.login}:${apiCubic.users.billing.pass}`);

  try {
    const data = await requester({
      method: 'post',
      url: apiCubic.host + apiCubic.endpoints.promoCodeActivate,
      appendParams: false,
      extendHeadersWithSession: false,
      headers: {
        Authorization: `Basic ${authToken}`,
      },
      data: {
        contractCode: contractNumber,
        promoCode: code,
        language: INIT_UI_LANGUAGE,
      },
    });
    innerAnalyticsVolia.postEvent({
      eventGroup: 'promo codes',
      eventName: 'click submit',
      eventValue: `${code}; ${get(data, 'error.code', 'success')}`,
    });
    dispatch({ type: types.FETCH_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: types.FETCH_ERROR, payload: error });
  } finally {
    dispatch(hideLoader());
  }
};

export const resetResult = () => ({ type: types.RESET_RESULT });
